import { render, staticRenderFns } from "./MerchantManagement.vue?vue&type=template&id=39c7ecc9&scoped=true"
import script from "./MerchantManagement.vue?vue&type=script&lang=js"
export * from "./MerchantManagement.vue?vue&type=script&lang=js"
import style0 from "./MerchantManagement.vue?vue&type=style&index=0&id=39c7ecc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c7ecc9",
  null
  
)

export default component.exports